import { userActions } from '@va/constants';
import { FilterIconV2, GlobeIcon, HeatmapIcon, NavEcommerceCustomers, PagesIcon, VideoCameraIcon } from '@va/icons';
import { useTranslate } from '@va/localization';
import { hasPermission } from '@va/standalone/shared/selectors';
import { isWixApp } from '@va/util/helpers';
import { useSelector } from 'react-redux';
import { PageUrlAction } from './PageUrlAction';
import { usePageUrlActions } from './usePageUrlActions';

type PageUrlActionsTooltipProps = {
  pageUrl: string;
};

export const InternalUrlActions = ({ pageUrl }: PageUrlActionsTooltipProps) => {
  const translate = useTranslate();
  const { viewPages, createHeatmap, createFunnel, viewRecordings, viewCustomEvents, viewVisitors } =
    usePageUrlActions(pageUrl);

  const hasCreatePermission = useSelector((state) => hasPermission(state, userActions.Create));

  return (
    <>
      <PageUrlAction onClick={viewPages} tooltip={translate('pageUrlAction.viewPages.tooltip')}>
        <PagesIcon color='#FFFFFFBF' />
      </PageUrlAction>
      <PageUrlAction
        onClick={createHeatmap}
        tooltip={
          hasCreatePermission ? translate('pageUrlAction.createHeatmap.tooltip') : translate('tooltips.contributorRole')
        }
        disabled={!hasCreatePermission}
      >
        <HeatmapIcon color='#FFFFFFBF' />
      </PageUrlAction>
      <PageUrlAction
        onClick={createFunnel}
        tooltip={
          hasCreatePermission ? translate('pageUrlAction.createFunnel.tooltip') : translate('tooltips.contributorRole')
        }
        disabled={!hasCreatePermission}
      >
        <FilterIconV2 color='#FFFFFFBF' />
      </PageUrlAction>
      {/* Custom events are not supported by Wix dashboard */}
      {!isWixApp() && (
        <PageUrlAction onClick={viewCustomEvents} tooltip={translate('pageUrlAction.viewCustomEvents.tooltip')}>
          <GlobeIcon color='#FFFFFFBF' className='w-5 h-5' />
        </PageUrlAction>
      )}
      <PageUrlAction onClick={viewRecordings} tooltip={translate('pageUrlAction.viewRecordings.tooltip')}>
        <VideoCameraIcon color='#FFFFFFBF' />
      </PageUrlAction>
      <PageUrlAction onClick={viewVisitors} tooltip={translate('pageUrlAction.viewVisitors.tooltip')}>
        <NavEcommerceCustomers color='#FFFFFFBF' />
      </PageUrlAction>
    </>
  );
};
